import { TwoStepVerificationEvent } from '@/services/analytics/events';
import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgLockedOutModal',
})
export default class CmgLockedOutModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.lockedOutModal.visible;
  }

  @Watch('visible', { immediate: true })
  async visibleChanged(newVisible: boolean) {
    if (newVisible) {
      this.$services.analytics.send(new TwoStepVerificationEvent(AnalyticsEventType.TwoStepVerificationLockout));
    }
  }

  onClose() {
    this.$services.ui.setModalVisibility('lockedOutModal', false);
    this.$services.ui.setModalVisibility('signIn', false);
  }
}
